import { render, staticRenderFns } from "./FrameHeader.vue?vue&type=template&id=163fe517&scoped=true&"
import script from "./FrameHeader.vue?vue&type=script&lang=js&"
export * from "./FrameHeader.vue?vue&type=script&lang=js&"
import style0 from "./FrameHeader.vue?vue&type=style&index=0&id=163fe517&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163fe517",
  null
  
)

export default component.exports